// extracted by mini-css-extract-plugin
export default {"wrapper":"sales-nav_wrapper__4Fuv8"};